import { useSearchParams } from 'react-router';
import ClientCompany from './ClientCompany';
import NavTab from '../../components/NavTab';
import LayoutAdmin from '../../components/layouts/LayoutAdmin';
import InfoCompany from './InfoCompany';

export default function Company() {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('page') || 'Informations';

  return (
    <LayoutAdmin header="Company">
      <NavTab tabs={['Informations', 'Clients']} />

      <div className="">
        {activeTab === 'Informations' && <InfoCompany />}
        {activeTab === 'Clients' && <ClientCompany />}
      </div>
    </LayoutAdmin>
  );
}
